export default function Machines_A_9 (number = 1) {
  return {
    name: '微型聚变发电站',
    icon: '/static/img/machines/a9.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_A/Machines_A_9.js